import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LegacySessionService } from '../legacy-session.service';
import { OidcStorageService } from './oidc-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthModeService {
  private readonly overrideKey = 'opogo.oidc.testOverride';
  private selectedOidc?: boolean;
  // These public forms remain part of the legacy Learn/registration integration.
  private readonly legacyPaths = new Set([
    '/signup', '/confirmemail', '/embeddedsignin', '/embeddedsigninpanel',
    '/set-password', '/forgotten-password', '/signedin', '/signout',
    '/forgot-password', '/forgot-password-email-confirmation', '/change-password',
    '/resetpassword', '/resetpasswordsuccessful', '/sorry',
  ]);

  constructor(private legacy: LegacySessionService, private oidcStorage: OidcStorageService) {}

  get isLegacyIntegration(): boolean { return this.isLegacyPage(new URL(window.location.href)); }

  get preservingLegacySession(): boolean {
    return environment.useNewIdp && !this.isLegacyIntegration && !this.useOidc();
  }

  useOidc(url = window.location.href): boolean {
    const target = new URL(url, window.location.origin);
    const path = target.pathname.toLowerCase().replace(/\/$/, '') || '/';
    if (this.isLegacyPage(target)) return false;
    if (path === '/login' && target.searchParams.get('useNewIdp') === 'true') {
      sessionStorage.setItem(this.overrideKey, 'true');
    }
    if (sessionStorage.getItem(this.overrideKey) === 'true') return true;
    // Pin the selected flow for this document. Expiry/rejection of a preserved
    // legacy session reloads the app before any OIDC account data can be loaded.
    return this.selectedOidc ??= environment.useNewIdp &&
      (!!this.oidcStorage.readSession() || !this.legacy.valid);
  }

  private isLegacyPage(target: URL): boolean {
    const path = target.pathname.toLowerCase().replace(/\/$/, '') || '/';
    return this.legacyPaths.has(path) || path.startsWith('/reference/');
  }
}
